// src\services\PlayListDataService.js
import http from '../http-common';

class PlayListDataService {
  getAll() {
    return http.get("/playlist-master");
  }

  getAllType(id) {
    return http.get(`/playlist-master/type/${id}`);
  }

  get(id) {
    return http.get(`/playlist-master/edit/${id}`);
  }

  create(data) {
    return http.post("/playlist-master/add", data);
  }

  update(id, data) {
    return http.put(`/playlist-master/update/${id}`, data);
  }

  delete(id) {
    return http.put(`/device-group/delete/${id}`);
  }
}

export default new PlayListDataService();
